export default class ShowcaseObject {
    constructor(model) {
        this.id = (model && model.id) || null;
        this.internal = (model && model.internal) || null;
        this.title = (model && model.title) || {};
        this.extendedTitle = (model && model.extendedTitle) || {};
        this.descriptions = (model && model.descriptions) || {
            explorer: {},
            academic: {},
            extra: {},
        };
        this.isTop = (model && model.isTop) || false;
        this.showcaseId = (model && model.showcaseId) || null;
        this.infoItems = (model && model.infoItems) || [];
        this.infoItemIds = (model && model.infoItemIds) || [];
        this.mediaLinks = (model && model.mediaLinks) || [];
        this.startPublishingDate = (model && model.startPublishingDate) || null;
        this.endPublishingDate = (model && model.endPublishingDate) || null;
        this.published = (model && model.published) || false;
        this.qrCode = (model && model.qrCode) || {};
        this.showcase = (model && model.showcase) || null;
    }
}
